import {Component, OnInit, ViewChild} from '@angular/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {CustomerService, RootService} from 'src/app/services';
import {FormBuilder} from '@angular/forms';
import {CallService} from 'src/app/services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {
  showCustomers = true;
  isSpinning = false;
  createCall = false;
  // danh sách khách hàng
  loading;
  changeAction;
  // tslint:disable-next-line:variable-name
  list_province = [];
  keyword;
  // tslint:disable-next-line:variable-name
  province_id;
  query;
  // tslint:disable-next-line:variable-name
  list_id = [];
  customers = [];
  total = 10;
  pageIndex = 1;
  pageSize = 10;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId = {};
  actions = [
    {
      label: 'Export',
      value: 1
    }
  ];
  // end danh sách khách hàng
  imageFalse = [];
  form = this.fb.group({});
  quotaVoiceCall: any = null

  // @ts-ignore
  @ViewChild('call') call;
  // @ts-ignore
  @ViewChild('contactGroup') contactGroup;

  phone;

  isShowModalSelectPhone: boolean = false
  unsubsribe$ = new Subject();
  defaultPhone: any = ""
  defaultToken: any = ""
  ownerPhone: any = ""
  ownerToken: any = ""
  selectedPhone: any = ""
  selectedToken: any = ""
  selectedCustomer: any = null
  userId: any = null

  constructor(
    private customerService: CustomerService,
    private rootService: RootService,
    private notification: NzNotificationService,
    private fb: FormBuilder,
    private callService: CallService
  ) {
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.showCustomers = true;
    this.isSpinning = false;
    this.changeAction = undefined;
    this.loadData();
    this.loadCities();
    this.getClientToken()
  }

  // danh sách khách hàng
  loadCities() {
    this.rootService.listCities().subscribe(
      res => {
        if (res.code === 1) {
          this.list_province = res.data.items;
          return;
        }
        this.list_province = [];
      },
      error => {
        this.list_province = [];
      }
    );
  }

  loadData() {
    this.loading = true;
    this.query = {
      keyword: this.keyword ? this.keyword.trim() : '',
      page: this.pageIndex,
      page_size: this.pageSize
    };
    if (this.province_id) {
      this.query.province_id = this.province_id;
    }
    this.customerService.list(this.query).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.total = res.data.totalElement;
          this.customers = res.data.items;
          return;
        }
        this.notification.create(
          'error',
          'Lấy danh sách khách hàng thất bại',
          res.message
        );
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Lấy danh sách khách hàng thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
    this.refreshStatus();
  }

  search() {
    this.pageIndex = 1;
    this.loadData();
  }

  reset() {
    this.keyword = undefined;
    this.province_id = undefined;
    this.pageIndex = 1;
    this.loadData();
  }

  export() {
    this.loading = true;
    console.log(123123123)
    this.query = {
      keyword: this.keyword ? this.keyword.trim() : '',
      page: this.pageIndex,
      page_size: this.pageSize,
      ids: this.list_id.length > 0 ? this.list_id.toString() : undefined,
      export_all: this.list_id.length === 0,
    };
    this.customerService.exportCustomer(this.query).subscribe(
      res => {
        console.log('res' , res)
        this.loading = false;
        this.rootService.export(res, 'Danh sách khách hàng.xlsx');
        this.loading = false;
        this.mapOfCheckedId = {};
        this.list_id = [];
        this.refreshStatus();
      },
      error => {
        this.loading = false;
        this.notification.error(
          'Export khách hàng thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  actionsButton(event) {
    this.changeAction = event;
  }

  buttonSubmit() {
    if (this.changeAction === 1) {
      this.export();
    }
  }

  checkAll(value: boolean) {
    this.customers.forEach(item => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }

  refreshStatus() {
    if (this.customers.length > 0) {
      this.isAllDisplayDataChecked = this.customers.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate = this.customers.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;
    for (const key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }

  showCustomers$() {
    this.showCustomers = true;
  }

  hideCustomers$() {
    this.showCustomers = false;
  }

//  end ds khách hàng

  /*Check link image error*/
  checkImageErr(imageError) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink) {
    if (!this.imageFalse.includes(id)) {
      // @ts-ignore
      window.open(imageLink, '_blank');
    }
  }

  /*End Check link image error*/
  showCall() {
    this.phone = undefined;
    this.createCall = true;
    this.getQuotaVoiceCall()
  }

  hideCall() {
    this.createCall = false;
  }

  getPhone(event) {
    this.phone = this.phone !== undefined ? this.phone + event : event;
  }

  fCreateCall() {
    if (this.phone === undefined) {
      return;
    }
    if (this.phone.trim().length) {
      const data = {
        phone: this.phone,
        avatat: '',
        name: '',
        email: ''
      };
      let clientToken = {
        phone: this.selectedPhone,
        token: this.selectedToken,
        userId : this.userId
      }
      this.createCall = false;
      this.fCall(data, false, clientToken);
    }
  }

  fCall(data, type: boolean, clientToken: any) {
    this.call.showModal(data, type, clientToken);
  }

  // hideModal(): void {
  //   this.contactGroup.handleCancel();
  //
  // }

  showModalSelectPhone(item: any) {
    this.isShowModalSelectPhone = true
    this.selectedCustomer = item;
    this.getQuotaVoiceCall()
  }

  onCancelModalSelectPhone() {
    this.isShowModalSelectPhone = false;
    this.selectedCustomer = null
  }

  onOkModalSelectPhone() {
    this.isShowModalSelectPhone = false;
    let clientToken = {
      phone: this.selectedPhone,
      token: this.selectedToken,
      userId : this.userId
    }
    console.log(clientToken);

    this.fCall(this.selectedCustomer, true, clientToken)
  }

  showStatusPhone() {
    this.contactGroup.showModal();
  }

  getQuotaVoiceCall() {
    let query = {
      serviceType: "VOICE_CALL"
    }
    this.customerService.getQuotaByServiceType(query).subscribe((res: any) => {
      if(res.code === 1) {
        this.quotaVoiceCall = res.data
      }
    })
  }

  getClientToken() {
    this.callService.getClientToken().pipe(takeUntil(this.unsubsribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.defaultPhone = res.data.default && res.data.default.phoneNumber ? res.data.default.phoneNumber : ""
          this.defaultToken = res.data.default && res.data.default.token ? res.data.default.token : ""
          this.ownerPhone = res.data.own && res.data.own.phoneNumber ? res.data.own.phoneNumber : ""
          this.ownerToken = res.data.own && res.data.own.token ? res.data.own.token : ""
          this.userId = res.data.userId
          this.selectedPhone = this.defaultPhone ? this.defaultPhone : this.ownerPhone
          this.selectedToken = this.defaultToken ? this.defaultToken : this.ownerToken
        }
      }
    );
  }
}
